import React, { useState, useEffect } from "react";
import {
  LogHeader,
  MainHeading,
  InnerHeader,
} from "../../../components/common/Header/index";
import LatestReleaseFilter from "./LatestReleaseFilter";
import { releasesPic } from "../../../resources/images/index";
import Cards from "../../../components/common/Cards";
import { Grid, Button } from "@material-ui/core";
import { useHistory, useParams } from "react-router";
import Loader from "../../../components/common/Loader";
import SearchHighlight from "../../../components/common/SearchHighlight";
import { useDispatch, useSelector } from "react-redux";
import { pubReleaseActions } from "../../../store/pubRelease/pubReleaseActions";
import moment from "moment";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import { accountActions } from "../../../store/accounts/accountActions";
import { toast } from "react-toastify";
import {
  GridSelected,
  GridUnSelected,
  ListSelected,
  ListUnSelected,
} from "../../../ofishadmin/views/LeftNav/SvgIcons";
import Footer from "../../../components/common/Footer/Footer";

function LogLatestReleases(props) {
  document.title = "OFish - Latest Releases";

  const history = useHistory();
  const [isLoading, setLoading] = useState(false);
  const [showViewAll, setShowViewAll] = useState(true);
  const [isFilter, setIsFilter] = useState(true);
  const [releaseSrch, setReleaseSrch] = useState("");
  const [isSearch, setIsSearch] = useState(false);
  const [isList, setIsList] = useState(false);
  const [isGrid, setIsGrid] = useState(false);
  const [isViewClicked, setIsViewClicked] = useState(false);
  const [catName, setCatName] = useState("");
  const [childName, setChildName] = useState("");

  const dispatch = useDispatch();

  const { releasesWithCategory, selectedPRCategory, pubReleaseCategory } =
    useSelector(state => state.PubReleaseReducer);
  console.log(selectedPRCategory);
  const onSearch = () => {
    if (releaseSrch.trim() !== "") {
      setIsSearch(true);
      setLoading(true);
      setShowViewAll(false);
      const filterPayload = {
        releaseDate: 0,
        categoryIds: [],
        take: 100,
        skip: 0,
        title: releaseSrch,
        dataType: ["LatestOnly"],
      };
      dispatch(pubReleaseActions.onGetPubRelWithCategory(filterPayload)).then(
        res => {
          setLoading(false);
        }
      );
    } else {
      loadData();
    }
  };

  const onDdetail = item => {
    if (item.urlSlug) {
      history.push("/releases/category/" + item.urlSlug);
    } else {
      toast.error("No record found");
    }
  };
  const { slug } = useParams();
  useEffect(() => {
    if (slug && pubReleaseCategory?.length > 0) {
      const catData = pubReleaseCategory.filter(x => x.urlSlug === slug);
      if (catData?.length > 0) {
        const fiterObj = {
          id: catData[0].id,
          name: catData[0].name,
          urlSlug: catData[0].urlSlug,
        };
        dispatch(pubReleaseActions.onAddValueInFilter(fiterObj));
        setLoading(true);
        const filterPayload = {
          releaseDate: 0,
          categoryIds: [catData[0].id],
          take: 100,
          skip: 0,
          title: "",
          dataType: ["CategoryOnly"],
        };
        dispatch(pubReleaseActions.onGetPubRelWithCategory(filterPayload)).then(
          res => {
            setLoading(false);
          }
        );
      }
    }
  }, [slug, pubReleaseCategory]);

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(accountActions.onAddUserSession(window.location.href));
    if (selectedPRCategory?.length > 0) {
      let catIds = [];
      selectedPRCategory.forEach(element => {
        catIds.push(element.id);
      });
      setLoading(true);
      const filterPayload = {
        releaseDate: 0,
        categoryIds: catIds,
        take: 100,
        skip: 0,
        title: "",
        dataType: ["CategoryOnly"],
      };
      dispatch(pubReleaseActions.onGetPubRelWithCategory(filterPayload)).then(
        res => {
          setLoading(false);
        }
      );
    } else {
      loadData();
    }
  }, []);

  const loadData = () => {
    setLoading(true);
    setShowViewAll(true);
    setIsSearch(false);
    setReleaseSrch("");
    const releaseData = {
      releaseDate: 0,
      categoryIds: [],
      take: 3,
      skip: 0,
      title: "",
      dataType: ["LatestOnly", "CategoryOnly"],
    };
    const catIds = [];
    dispatch(pubReleaseActions.onGetPubRelWithCategory(releaseData)).then(
      res => {
        if (res && res.success) {
          dispatch(pubReleaseActions.onGetPubCategories()).then(relCat => {
            if (relCat && relCat.success) {
              dispatch(pubReleaseActions.onGetPubRelDateFilter(catIds)).then(
                relDate => {
                  setLoading(false);
                }
              );
            } else {
              setLoading(false);
              if (relCat) {
                toast.error(relCat.message);
              }
            }
          });
        } else {
          if (res) {
            toast.error(res.message);
          }
          setLoading(false);
        }
      }
    );
  };

  const viewAllData = (item, isCategory) => {
    if (item.groupId !== 0 && isCategory) {
      const fiterObj = {
        id: item.groupId,
        name: item.groupBy,
        urlSlug: item.urlSlug,
      };
      dispatch(pubReleaseActions.onAddValueInFilter(fiterObj));
    }
    setIsViewClicked(true);
    setLoading(true);
    let dataTypeval = "";
    if (item.groupId === 0) {
      dataTypeval = "LatestOnly";
    } else {
      dataTypeval = "CategoryOnly";
    }
    const filterPayload = {
      releaseDate: 0,
      categoryIds: item.groupId !== 0 ? [item.groupId] : [],
      take: 100,
      skip: 0,
      title: "",
      dataType: [dataTypeval],
    };
    dispatch(pubReleaseActions.onGetPubRelWithCategory(filterPayload)).then(
      res => {
        setLoading(false);
        setShowViewAll(false);
      }
    );
  };

  const viewChildData = (rel, item) => {
    setChildName(rel.value);
    setCatName(item);
    setLoading(true);
    let dataTypeval = "CategoryOnly";
    const filterPayload = {
      releaseDate: 0,
      categoryIds: rel.id !== "0" ? [parseInt(rel.id)] : [],
      take: 100,
      skip: 0,
      title: "",
      dataType: [dataTypeval],
    };
    dispatch(pubReleaseActions.onGetPubRelWithCategory(filterPayload)).then(
      res => {
        setLoading(false);
        setShowViewAll(false);
      }
    );
  };

  const ShowListView = () => {
    setIsList(true);
    setIsGrid(false);
  };

  const ShowGridView = () => {
    setIsList(false);
    setIsGrid(true);
  };

  return (
    <div className='releasesWrapper'>
      {isLoading ? <Loader /> : null}
      <LogHeader />
      <MainHeading headerSubHeading='Latest Releases'>
        <div className='publicBodyTwoColumn'>
          <div className='leftFiletBar'>
            {!showViewAll && isFilter && (
              <div className='viewAllBtn'>
                <span className='toggleGrids'>
                  <span onClick={ShowGridView}>
                    {" "}
                    {isGrid ? <GridSelected /> : <GridUnSelected />}{" "}
                  </span>
                  <span onClick={ShowListView}>
                    {" "}
                    {isList ? <ListSelected /> : <ListUnSelected />}{" "}
                  </span>
                </span>
              </div>
            )}
            <LatestReleaseFilter
              startLoading={() => setLoading(true)}
              stopLoading={() => setLoading(false)}
              showButton={() => setIsFilter(true)}
              hideButton={() => setIsFilter(false)}
              loadData={() => loadData()}
              searchPage={() => onSearch()}
              onChange={e => setReleaseSrch(e.target.value)}
              value={releaseSrch}
            />
          </div>
          <div className='rightContentArea'>
            <InnerHeader
              picture={releasesPic}
              text='Find press releases and relevant assets from Aquatic AV'
              heading='Latest Releases'
              searchPage={() => onSearch()}
              onChange={e => setReleaseSrch(e.target.value)}
              value={releaseSrch}
              textPlace='Search release'
            />

            {releasesWithCategory?.length > 0 &&
              releasesWithCategory.map((item, index) => (
                <div
                  key={index}
                  className='boxMainWrapper eventsWrapper releaseInnerWrapper'>
                  <div className='releaseMainGridWrapper'>
                    {!showViewAll && (
                      <>
                        <div
                          className={`viewAllBtn ${
                            isViewClicked ? "innerToggle" : ""
                          }`}>
                          {isViewClicked && (
                            <span className='toggleGrids'>
                              View As
                              <span onClick={ShowGridView}>
                                {" "}
                                {isGrid ? (
                                  <GridSelected />
                                ) : (
                                  <GridUnSelected />
                                )}{" "}
                              </span>
                              <span onClick={ShowListView}>
                                {" "}
                                {isList ? (
                                  <ListSelected />
                                ) : (
                                  <ListUnSelected />
                                )}{" "}
                              </span>
                            </span>
                          )}
                        </div>
                      </>
                    )}
                    {isSearch ? (
                      <h2>{`${
                        item.data?.length
                      }${" results found for `"}${releaseSrch}${"`"}`}</h2>
                    ) : (
                      <h2
                        className={`${
                          childName ? "innerCategoryHeading" : ""
                        }`}>
                        <span>
                          {!item.isParent && item.groupId !== 0 && (
                            <h2
                              onClick={() => {
                                viewAllData(catName, false);
                              }}>
                              {catName.groupBy}
                              {childName !== "" && (
                                <ArrowForwardIosIcon
                                  style={{
                                    color: "#49b8ef",
                                    margin: "20px 10px",
                                    fontSize: "15px",
                                  }}
                                />
                              )}
                            </h2>
                          )}
                          {item.groupBy}
                        </span>
                        {showViewAll &&
                          isFilter &&
                          selectedPRCategory?.length === 0 && (
                            <div className='viewAllBtn'>
                              {selectedPRCategory &&
                                selectedPRCategory.length === 0 && (
                                  <Button
                                    color='primary'
                                    size='small'
                                    onClick={() => viewAllData(item, true)}>
                                    View All
                                  </Button>
                                )}
                            </div>
                          )}
                      </h2>
                    )}
                  </div>
                  <Grid container spacing={3} style={{ marginTop: "15px" }}>
                    {selectedPRCategory &&
                      selectedPRCategory.length > 0 &&
                      item.childCategories &&
                      item.childCategories?.length > 0 &&
                      item.childCategories.map((rel, i) => (
                        <Grid key={i} item md={4}>
                          <span
                            className='subCategoryHeading'
                            onClick={() => {
                              viewChildData(rel, item);
                            }}>
                            <ArrowForwardIosIcon /> {rel.value}
                          </span>
                        </Grid>
                      ))}
                  </Grid>
                  <div
                    className={`cards smallCard ${
                      isList ? "gridListView" : ""
                    }`}>
                    <Grid container spacing={3} style={{ marginTop: "15px" }}>
                      {item.data &&
                        item.data?.length > 0 &&
                        item.data.map((rel, i) => (
                          <Grid key={i} item md={4}>
                            <Cards
                              picture={
                                rel.imageUrl
                                  ? rel.imageUrl
                                  : "/static/images/cards/contemplative-reptile.jpg"
                              }
                              subheading={
                                <SearchHighlight
                                  text={rel.title}
                                  highlight={releaseSrch}
                                />
                              }
                              cardDescription='Release Subtitle Release Subtitle Release Subtitle Release Subtitle Release Subtitle Release Subtitle Release Subtitle Release Subtitle Release Subtitle Release Subtitle '
                              cardtext={moment(rel.announcementDate).format(
                                "MMMM, DD, YYYY"
                              )}
                              onClick={() => onDdetail(rel)}
                            />
                          </Grid>
                        ))}
                    </Grid>
                  </div>
                </div>
              ))}
            {releasesWithCategory?.length === 0 && (
              <div className='releaseInnerWrapper noCategory'>
                <div className='releaseMainGridWrapper'>
                  <span>
                    <h2
                      onClick={() => {
                        viewAllData(catName, false);
                      }}>
                      {catName.groupBy}
                    </h2>
                    {childName !== "" && (
                      <ArrowForwardIosIcon style={{ color: "#49b8ef" }} />
                    )}
                    <h2>{childName}</h2>
                  </span>
                  <span>No Releases Found</span>
                </div>
              </div>
            )}
          </div>
        </div>
        <Footer />
      </MainHeading>
    </div>
  );
}

export default LogLatestReleases;
